/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2024
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import settings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
import styles from './leaving-ibm.scss';
import StableSelectorMixin from '../../globals/mixins/stable-selector';
import { carbonElement as customElement } from '@carbon/web-components/es/globals/decorators/carbon-element.js';

const { stablePrefix: c4dPrefix } = settings;

/**
 * The supplemental content of leaving IBM modal.
 *
 * @element c4d-leaving-ibm-modal-supplemental
 */
@customElement(`${c4dPrefix}-leaving-ibm-modal-supplemental`)
class C4DLeavingIbmModalSupplemental extends StableSelectorMixin(LitElement) {
  /**
   * The shadow slot this supplemental content should be in.
   */
  @property({ reflect: true })
  slot = 'supplemental';

  render() {
    return html` <slot></slot> `;
  }

  static get stableSelector() {
    return `${c4dPrefix}--leaving-ibm-modal-supplemental`;
  }

  // `styles` here is a `CSSResult` generated by custom WebPack loader
  static styles = styles;
}

/* @__GENERATE_REACT_CUSTOM_ELEMENT_TYPE__ */
export default C4DLeavingIbmModalSupplemental;
